module.exports = __webpack_public_path__ + "image-7bec10b868ea.png";